import { useEffect, useState } from 'react';
import { IApiGetConsentFormReportParam } from '../types/api';
import { IResponseDataBody } from 'services/response';
import reportApis from '../apis';
import { DATE_FORMAT } from 'features/appointment/utils/format';
import moment from 'moment';
import { IPrintCheckHistoryItem, IPrintCheckHistoryParams, IPrintCheckHistoryResData } from '../types/check';

const initialParams: IPrintCheckHistoryParams = {
  startDate: moment().format(DATE_FORMAT),
  endDate: moment().format(DATE_FORMAT),
  page: 1,
  size: 1000,
};

const usePrintCPAList = () => {
  const [data, setData] = useState<IPrintCheckHistoryItem[]>([]);

  const mutate = async (_params: IApiGetConsentFormReportParam) => {
    try {
      const res: IResponseDataBody<IPrintCheckHistoryResData> = await reportApis.getPrintCheckHistory(_params);
      if (res.data.data?.content) {
        setData(res.data.data?.content || []);
      }
    } catch (error) {
      setData([]);
    }
  };

  useEffect(() => {
    mutate(initialParams);
  }, []);

  return { data, mutate };
};

export default usePrintCPAList;
